import { omit } from 'lodash'
import { API_CONST } from '../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

import { generateActions } from '../utils'
import { reformatLot } from '../../selectors/lots'
import { sendViewSearchList } from '../../helpers/tagManager'

const initial = {
  result: {
    funds: [],
    persons: [],
    lots: [],
    fixedpricelots: []
  }
}

const actions = generateActions('search/SEARCH')

export const search = createAction(
  API_CONST,
  query => ({
    actions,
    params: { query },
    url: 'search'
  })
)

export const clear = createAction('search/CLEAR')

export default handleActions({
  [clear]: state => ({ ...initial }),
  [actions[0]]: state => ({ ...initial }),
  [actions[1]]: (state, { payload }) => {
    let result = payload
    let lots = {}
    let fixedpricelots = {}

    payload.persons.map(el => {
      el.lots = el.lots.reduce((obj, item) => {
        obj[item._id] = item
        return obj
      }, {})
      lots = { ...lots, ...el.lots }
      el.fixedpricelots = el.fixedpricelots.reduce((obj, item) => {
        obj[item._id] = item
        return obj
      }, {})
      fixedpricelots = { ...fixedpricelots, ...el.fixedpricelots }
      el.image = el.photos ? (el.photos[0] || null) : null
      el.title = el.name
      delete el.lots
      delete el.fixedpricelots
      return omit(el, [ 'lots' ], [ 'fixedpricelots' ])
    })

    result.lots = Object.values(lots).map(el => reformatLot(el))
    result.fixedpricelots = Object.values(fixedpricelots).map(el => reformatLot(el))
 
    //отправляем данные о просмотре карточек лота
    sendViewSearchList(result.lots, result.fixedpricelots)

    return ({ ...state, result })
  },
  [actions[2]]: state => ({ ...initial })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/search.js